<h2 mat-dialog-title translate="MEETINGS.ADMIN.SOFT_DELETION.UNMARK_TITLE"></h2>
<mat-dialog-content>
  <p translate="MEETINGS.ADMIN.SOFT_DELETION.UNMARK_DESCRIPTION"></p>
  @if (canMoveDeletionDates) {
    <mat-checkbox [(ngModel)]="moveDeletionDates" name="move-deletion-dates" [disabled]="mustMoveDeletionDates">
      {{
        (fixedDeletionDate === null ? 'MEETINGS.ADMIN.SOFT_DELETION.UNMARK_MOVE_DELETION_DATES' : 'MEETINGS.ADMIN.SOFT_DELETION.UNMARK_MOVE_SOFT_DELETION_DATE')
          | translate
      }}
    </mat-checkbox>
  }
  @if (moveDeletionDates) {
    <div class="date-picker-section">
      <app-datetime-picker
        [(ngModel)]="softDeletionDate"
        name="soft-deletion-date"
        translationKey="MEETINGS.ADMIN.SOFT_DELETION.UNMARK_SOFT_DELETION_DATE_LABEL"
        [max]="fixedDeletionDate"
        [isDateInvalid]="!areDatesValid"
        [errorMessageKey]="softDeletionErrorKey"
      ></app-datetime-picker>
      @if (fixedDeletionDate === null) {
        <app-datetime-picker
          [(ngModel)]="deletionDate"
          name="deletion-date"
          translationKey="MEETINGS.ADMIN.SOFT_DELETION.UNMARK_DELETION_DATE_LABEL"
          [isDateInvalid]="!areDatesValid"
          errorMessageKey="MEETINGS.ADMIN.SOFT_DELETION.UNMARK_DELETION_DATES_MUST_BE_LATER"
        ></app-datetime-picker>
      } @else {
        <p class="fixed-deletion-date">
          {{ 'MEETINGS.ADMIN.SOFT_DELETION.UNMARK_DELETION_DATE_FIXED' | translate: { date: (fixedDeletionDate | date: 'medium') } }}
        </p>
      }
      <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button mat-button [mat-dialog-close]="dialogResult" [disabled]="!areDatesValid" translate="COMMON.SAVE" color="primary" cdkFocusInitial></button>
</mat-dialog-actions>
